import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvg = _resolveComponent("InlineSvg")!

  return (_openBlock(), _createBlock(_component_InlineSvg, {
    src: _ctx.getPath,
    onLoaded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('loaded', $event)))
  }, null, 8, ["src"]))
}